import { useState, useEffect } from 'react';
import * as _ from 'lodash';
import { Button, Box, Flex, ModalHeader } from '@vibe/core';
import { AppModal, AppModalContent, AppModalFooter } from '@gorilla/ui/src/components/AppModal';
import { SingleBoardPicker } from '../shared/components/SingleBoardPicker';

type BoardPickerModalProps = {
  show: boolean;
  onClose: (boardId?: number) => void;
};

export function BoardPickerModal({ show, onClose }: BoardPickerModalProps) {
  const [isViewportHeightBelow500, setIsViewportHeightBelow500] = useState<boolean>(window.innerHeight < 500);

  useEffect(() => {
    const handleResize = () => {
      setIsViewportHeightBelow500(window.innerHeight < 500);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  if (!show) {
    return null;
  }

  return (
    <AppModal
      show={show}
      onClose={() => {
        onClose();
      }}
      width="default"
      alertDialog={false}
      data-testid="board-picker-modal"
    >
      <ModalHeader title="Add a board" />
      <AppModalContent>
        <Box marginTop="medium">
          <SingleBoardPicker
            onBoardSelect={(boardId) => {
              onClose(boardId);
            }}
          />
        </Box>
      </AppModalContent>
      <AppModalFooter>
        <>
          {!isViewportHeightBelow500 && (
            <Flex gap={12} justify="end">
              <Box marginEnd="auto">
                <div style={{ lineHeight: '20px', color: '#afb0bd' }}>
                  Search for boards to append to your current template.{' '}
                  <strong>
                    Do you
                    <br />
                    want to append subitems?
                  </strong>{' '}
                  Simply search for <strong>"Subitems of"</strong>.
                </div>
              </Box>
              <Button
                kind="secondary"
                onClick={() => {
                  onClose();
                }}
              >
                Close
              </Button>
            </Flex>
          )}
        </>
      </AppModalFooter>
    </AppModal>
  );
}
